export enum DialogType {
  PLAIN = 'plain',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error'
}
